import { render, staticRenderFns } from "./brand_icons.vue?vue&type=template&id=52267f00&scoped=true&"
import script from "./brand_icons.vue?vue&type=script&lang=js&"
export * from "./brand_icons.vue?vue&type=script&lang=js&"
import style0 from "./brand_icons.vue?vue&type=style&index=0&id=52267f00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52267f00",
  null
  
)

export default component.exports